'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiFormLabel, {
  type FormLabelTypeMap as MuiFormLabelTypeMap,
} from '@mui/material/FormLabel';

type ExcludedMuiProps = '';

type CustomProps = {
  component?: ElementType;
};

type FormLabelTypeMap<
  P = CustomProps,
  D extends ElementType = MuiFormLabelTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiFormLabelTypeMap['props'], ExcludedMuiProps> & P;
};

export type FormLabelProps<
  D extends ElementType = MuiFormLabelTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiFormLabelTypeMap<P, D>, D>;

const FormLabelComponent = (
  props: FormLabelProps,
  ref: Ref<HTMLLabelElement>
) => {
  return <MuiFormLabel {...props} ref={ref} />;
};

FormLabelComponent.displayName = 'FormLabel';

export const FormLabel = forwardRef(
  FormLabelComponent
) as OverridableComponent<FormLabelTypeMap>;
